var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TipoProcessoEnum } from '../../../../model/enums/TipoProcessoEnum';
import { ShowContent } from '../../../../components/ShowContent';
import { DefaultContentStep } from '../../../../components/DefaultContentStep';
import React from 'react';
import { DadosConfimacaoRequerimento } from '../../View/DadosConfimacaoRequerimento';
export var QuartaAbaRequerimento = function (_a) {
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, tipoRequerimento = _a.tipoRequerimento, requerimento = _a.requerimento, onValidate = _a.onValidate, invertido = _a.invertido, onChange = _a.onChange, step = _a.step;
    var tiposComStepContent = [
        TipoProcessoEnum.REGULARIZACAO_RURAL,
        TipoProcessoEnum.CERTIDAO_LEGITIMIDADE_ORIG,
        TipoProcessoEnum.ESTD_CAD,
        TipoProcessoEnum.CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL,
        TipoProcessoEnum.CERTIDAO_FINS_USUCAPIAO_RURAL,
        TipoProcessoEnum.DECLARACAO_RECONHECIMENTO_LIMITES,
        TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO,
        TipoProcessoEnum.AVERBACAO_TITULO_JUDICIAL,
        TipoProcessoEnum.RETIFICACAO_TITULO_DEFINITIVO,
        TipoProcessoEnum.BUSCA_PESQUISA,
        TipoProcessoEnum.CERTIDAO_LOCALIZACAO_RURAL,
        TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA,
        TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA,
        TipoProcessoEnum.DECLARACAO_ASSENTADO,
        TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO,
        TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO,
        TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA,
        TipoProcessoEnum.MAPA_MEMORIAL,
    ];
    var setActiveStep = step[1];
    var renderStep = function (tipo) { return (_jsx(ShowContent, __assign({ show: tipoRequerimento === tipo }, { children: _jsx(DadosConfimacaoRequerimento, { requerimentoFieldErrorChange: function (erros) { return requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, erros)); }, onChange: function (_requerimento) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, _requerimento)); }, requerimentoFieldError: requerimentoFieldError, setActiveStep: setActiveStep, requerimento: requerimento, onValidate: onValidate, invertido: invertido }) }), tipo)); };
    return (_jsx("div", { children: _jsx(ShowContent, __assign({ show: true }, { children: _jsx(DefaultContentStep, __assign({ style: { paddingLeft: '19px' }, title: "Confirma\u00E7\u00E3o de Dados", subtitle: "Confirme os dados coletados e altere-os onde for necess\u00E1rio" }, { children: tiposComStepContent.map(renderStep) })) })) }));
};
